"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewCarFiles = exports.dataDepotAuth = exports.createCar = exports.decryptFile = exports.textUploadEncrypted = exports.uploadEncrypted = exports.uploadBuffer = exports.uploadText = exports.upload = exports.getAccessConditions = exports.applyAccessCondition = exports.fetchEncryptionKey = exports.revokeFileAccess = exports.getAuthMessage = exports.shareFile = exports.createWallet = exports.getFileInfo = exports.getUploads = exports.dealStatus = exports.getBalance = exports.getApiKey = exports.getQuote = void 0;
const getQuote_1 = __importDefault(require("./getQuote"));
exports.getQuote = getQuote_1.default;
const getApiKey_1 = __importDefault(require("./getApiKey"));
exports.getApiKey = getApiKey_1.default;
const getBalance_1 = __importDefault(require("./getBalance"));
exports.getBalance = getBalance_1.default;
const dealStatus_1 = __importDefault(require("./dealStatus"));
exports.dealStatus = dealStatus_1.default;
const getUploads_1 = __importDefault(require("./getUploads"));
exports.getUploads = getUploads_1.default;
const getFileInfo_1 = __importDefault(require("./getFileInfo"));
exports.getFileInfo = getFileInfo_1.default;
const createWallet_1 = __importDefault(require("./createWallet"));
exports.createWallet = createWallet_1.default;
// Encryption
const shareFile_1 = __importDefault(require("./encryption/shareFile"));
exports.shareFile = shareFile_1.default;
const getAuthMessage_1 = __importDefault(require("./encryption/getAuthMessage"));
exports.getAuthMessage = getAuthMessage_1.default;
const revokeFileAccess_1 = __importDefault(require("./encryption/revokeFileAccess"));
exports.revokeFileAccess = revokeFileAccess_1.default;
const fetchEncryptionKey_1 = __importDefault(require("./encryption/fetchEncryptionKey"));
exports.fetchEncryptionKey = fetchEncryptionKey_1.default;
const applyAccessCondition_1 = __importDefault(require("./encryption/applyAccessCondition"));
exports.applyAccessCondition = applyAccessCondition_1.default;
const getAccessConditions_1 = __importDefault(require("./encryption/getAccessConditions"));
exports.getAccessConditions = getAccessConditions_1.default;
// Upload
const files_1 = __importDefault(require("./upload/files"));
exports.upload = files_1.default;
const text_1 = __importDefault(require("./upload/text"));
exports.uploadText = text_1.default;
const decrypt_1 = __importDefault(require("./uploadEncrypted/decrypt"));
exports.decryptFile = decrypt_1.default;
const uploadBuffer_1 = __importDefault(require("./upload/buffer/uploadBuffer"));
exports.uploadBuffer = uploadBuffer_1.default;
const file_1 = __importDefault(require("./uploadEncrypted/encrypt/file"));
exports.uploadEncrypted = file_1.default;
const text_2 = __importDefault(require("./uploadEncrypted/encrypt/text"));
exports.textUploadEncrypted = text_2.default;
// Data Depot
const createCar_1 = __importDefault(require("./createCAR/createCar"));
exports.createCar = createCar_1.default;
const viewCarFiles_1 = __importDefault(require("./createCAR/viewCarFiles"));
exports.viewCarFiles = viewCarFiles_1.default;
const dataDepotAuth_1 = __importDefault(require("./createCAR/dataDepotAuth"));
exports.dataDepotAuth = dataDepotAuth_1.default;
exports.default = {
    getQuote: getQuote_1.default,
    getApiKey: getApiKey_1.default,
    getBalance: getBalance_1.default,
    dealStatus: dealStatus_1.default,
    getUploads: getUploads_1.default,
    getFileInfo: getFileInfo_1.default,
    createWallet: createWallet_1.default,
    shareFile: shareFile_1.default,
    getAuthMessage: getAuthMessage_1.default,
    revokeFileAccess: revokeFileAccess_1.default,
    fetchEncryptionKey: fetchEncryptionKey_1.default,
    applyAccessCondition: applyAccessCondition_1.default,
    getAccessConditions: getAccessConditions_1.default,
    upload: files_1.default,
    uploadText: text_1.default,
    uploadBuffer: uploadBuffer_1.default,
    uploadEncrypted: file_1.default,
    textUploadEncrypted: text_2.default,
    decryptFile: decrypt_1.default,
    createCar: createCar_1.default,
    dataDepotAuth: dataDepotAuth_1.default,
    viewCarFiles: viewCarFiles_1.default
};
